import React from 'react';
import Technologies from '../../technologies';
import Logo from '../../../assets/images/LogoBlue.png';
import classes from './style.module.scss';
import Office from '../../../assets/images/office.png';

const Banner = () => (
  <section className={classes.Banner}>
    <div className={classes.Description}>
      <div className='MainWrapper'>
        <div className={classes.TopContent}>
          <h1>
            ReactJS is a JavaScript library designed to build user interfaces
          </h1>
          <p>
            It is maintained by Facebook and a community of individual
            developers and companies. React can be used as a base in the
            development of single-page or mobile applications.
          </p>
          <img src={Office} alt='office' className={classes.TopContentImage} />
        </div>
        <div className={classes.BottomContent + ` TextStyles`}>
          <div className={classes.Logo}>
            <img src={Logo} alt='website logo' />
          </div>
          <h3>Get to know us better</h3>
          <p>
            Our main strength are our developers and the skillset, which they
            bring to the table. We make a special effort to ensure that they
            have the best tools and available resources, so they are capable of
            helping our clients achieve their goals. We direct our focus into a
            single technology, and that makes us the best React Development
            Company in Poland. We have been invited as speakers to the various
            events in Poland - such us ReactJS Warsaw. We’ve also had a pleasure
            to participate in the React Europe which is one of the global
            conferences. Those experiences have been a great opportunity to
            simply network, brainstorm, and stay in touch with the best minds in
            the industry.
          </p>
        </div>
        <div className={classes.TechnologiesList}>
          <p className={classes.SmallTitle}>
            React Poland is much more than just React JS!
          </p>
          <div className={classes.Technologies}>
            <Technologies
              react
              postgres
              mongo
              node
              sass
              redux
              webrtc
              hover
              scale
            />
          </div>
        </div>
      </div>
    </div>
    <div className={classes.Images}></div>
    <div className={classes.BcgWave}>
      <div className={classes.HeaderWave}>
        {/*todo: switch to SVG provided by Daria (in waiting for file)*/}
        <svg viewBox='0 0 500 150' preserveAspectRatio='none'>
          <path
            d='M0.00,49.98 C350.73,-12.33 352.42,249.17 500.00,49.98 L500.00,0.00 L0.00,0.00 Z'
            style={{ stroke: 'none', fill: '#0f82b7' }}
          />
        </svg>
      </div>
    </div>
  </section>
);

export default Banner;
